import React, { useState, useRef } from 'react';
import { UseMap } from 'react-map-gl';


import {
    Alert,
    Badge,
    Card,
    Input,
    Checkbox,
    Button,
    List,
    ListItem,
    ListItemPrefix,
    ListItemSuffix,
    Typography,
    IconButton,
    Radio,
    Tab,
    Tabs,
    TabsBody,
    TabsHeader,
    TabPanel,
    Select,
    Option,
    Textarea,
    Tooltip

} from "@material-tailwind/react";

import {
    PresentationChartBarIcon,
    ShoppingBagIcon,
    ArrowTopRightOnSquareIcon,
    MapIcon,
    ClipboardDocumentListIcon,
    UserCircleIcon,
    UsersIcon,
    Cog6ToothIcon,
    InboxIcon,
    InboxArrowDownIcon,
    PowerIcon,
    PencilIcon,
    TrashIcon,
    SparklesIcon,
    RectangleGroupIcon,
    BeakerIcon,
    FolderPlusIcon,
    //DocumentIcon,
    DocumentChartBarIcon,
    PaperClipIcon,
    FunnelIcon,

} from "@heroicons/react/24/outline";

import { FolderMinusIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import ShapeUnziper from './ShapeUnziper.jsx';

import * as turf from '@turf/turf'

import MapboxPanel from './MapBoxPanel.jsx';
import { json } from 'react-router-dom';
import Datepicker from "react-tailwindcss-datepicker";
import ConfirmDialog, { QueryDataDialog } from './ConfirmDialog.jsx';
import { showAlert } from './Alert.jsx';
import { geoportalGetParcelPolygon } from './geoportal.js';
import FileUploadCard from './FileUploadCard.jsx';
import { getFieldFiles, getFields, getUserFiles } from './AdminTools.jsx';
import DocumentIcon from './DocumentIcon.jsx';
import { features } from 'process';
import { matchFieldsResults } from './GeoTools.jsx';
import LabFilterCard from './LabFilterCard.jsx';

export default function ResultsProcessingAdvancedCard(props) {

    const [featureCollection, setFeatureCollection] = useState(JSON.parse(localStorage.getItem("featureCollection")) || emptyGeoJson);
    const [fields, setFields] = useState(JSON.parse(localStorage.getItem("fields")) || []);
    const [files, setFiles] = useState(JSON.parse(localStorage.getItem("files")) || []);
    const [ownerid, setOwnerId] = useState(props.clientid);

    const [results, setResults] = useState([]); //
    const [labFile, setLabFile] = useState();
    const [labFeatures, setLabFeatures] = useState({});
    const [boundingBox, setBoundingBox] = useState();


    const [shape, setShape] = useState();
    const [action, setAction] = useState('create');
    const [fieldid, setFieldId] = useState(0);
    const [fileid, setFileId] = useState();


    const [examTimeStamp, setExamTimeStamp] = useState();
    const [examDate, setExamDate] = useState();
    const [examDateString, setExamDateString] = useState();
    const [title, setTitle] = useState();

    const [bboxAll, setBBoxAll] = useState();

    const [fileIsSelected, setFileIsSelected] = useState(false);
    const [fileIsFiltered, setFileIsFiltered] = useState(false);
    const [clearOnExit, setClearOnExit] = useState(false);
    const [session, setSession] = useState(localStorage.getItem("session") || null);
    const [fileData, setFileData] = useState();

    const [refreshAfterExit, setRefreshAfterExit] = useState(false);
    const [closeOnSend, setCloseOnSend] = useState(false);
    const [showConfirmClear, setShowConfirmClear] = useState(false);
    const [sendDisabled, setSendDisabled] = useState(true);
    const [showLabFilterCard, setShowLabFilterCard] = useState(false);


    const [fileInfo, setFileInfo] = useState();
    const [fileName, setFileName] = useState();
    const [extension, setExtension] = useState();
    const [fileSize, setFileSize] = useState();
    const [fileType, setFileType] = useState();
    const [fileDate, setFileDate] = useState();








    const emptyGeoJson = {
        "type": "FeatureCollection",
        features: []
    }

    let collection = emptyGeoJson;
    let expectFeatures = 0;


    React.useEffect(() => {
        init(props);

        //localStorage.setItem("lockvehicles", "true");
        //if (props.fieldid) getFieldFiles(session, props.fieldid, updateFiles,"json");   //// important    

    }, []);


    React.useEffect(() => {
        console.log("files");
        console.log(files);
        let res = files.filter(f => f.category == "results");
        setResults(res);
        console.log("event [files] res");
        console.log(res);                
        if (res.length>0)
        {
        console.log("auto select newest result file");
        var autolab=res[res.length-1];
        console.log(autolab);
        setLabFile(autolab);
        setFileId(autolab.id);
        setAction("update");
        }
        

    }, [files]);


    function init(props) {
        getFields(session, buildFieldsFeatures, ownerid);
        getUserFiles(session, ownerid, setFiles, "json");
        let bounds = turf.bbox(featureCollection);
        let resizedbounds = resizeBoundingBox(bounds);
        setBoundingBox(resizedbounds);
        setAction('update');
    }




    function resizeBoundingBox(bounds) {
        var point1 = turf.point([bounds[0], bounds[1]]);
        var point2 = turf.point([bounds[2], bounds[3]]);
        var bearing = turf.bearing(point1, point2);
        var distance = turf.distance(point1, point2);
        var p1 = turf.destination(point1, -0.3 * distance, bearing);
        var p2 = turf.destination(point2, 0.3 * distance, bearing);
        var box = [p1.geometry.coordinates[0], p1.geometry.coordinates[1], p2.geometry.coordinates[0], p2.geometry.coordinates[1]];
        return box;
    }


    function applyFeatureCollection(collection) {
        localStorage.setItem('featureCollection', JSON.stringify(collection));
        dispatchEvent(new Event("featureCollectionChanged"));
    }


    function applyBoundingBox(bounds) {
        localStorage.setItem('boundingBox', JSON.stringify(bounds));
        dispatchEvent(new CustomEvent('boundingBoxChanged', { detail: bounds })); //cool can pass arguments in event this way
    }




    function buildFieldsFeatures(fields) {
        let newfc = {
            type: "FeatureCollection",
            features: []
        }

        fields.forEach(field => {
            let fieldshape = JSON.parse(field.shape);

            fieldshape.features.forEach(feature => {
                feature.fieldid = field.id;
                feature.properties.nazwa = field.name;
                feature.properties.value = 5;
                newfc.features.push(feature);
            });
        });

        if (newfc.features.length == 0) {
            fields.forEach(field => {
                let fieldshape = JSON.parse(field.shape);
                fieldshape.features.forEach(feature => {
                    feature.properties.value = 1;
                    newfc.features.push(feature);
                });
            }
            );
        }

        console.log("new feature collection");
        console.log(newfc);

        setFeatureCollection(newfc);
        setTimeout(() => showGeoJson(newfc, false), 300);
        //showGeoJson(newfc, false);


    }


    function showGeoJson(feature, refresh) {
        console.log('showGeoJson');

        if (!feature) return;
        console.log('showGeoJson2');

        let collection;
        try {
            if (feature.type == "FeatureCollection") {
                collection = feature;
            }
            else if (feature.type == "Feature") {
                collection = {
                    "type": "FeatureCollection",
                    features: [feature]
                }
            }
        } catch { console.log('unknown feature type'); }

        if (collection.features.length == 0) {
            console.log('No features to display');
            return;
        }

        //console.log('Featrue Collection ready to display');
        //console.log(collection);
        //setFeaturesCount(collection.features.length);
        //set value based on examined.timestamp



        //console.log('Featrue Collection with colors');
        //console.log(collection);

        let area = turf.area(feature) / 10000.0;
        let bounds = turf.bbox(feature);
        let center = turf.center(feature);
        let resizedbounds = resizeBoundingBox(bounds);

        //grid(resizedbounds, collection);
        //gridtest(resizedbounds, collection);

        applyFeatureCollection(collection);
        applyBoundingBox(resizedbounds);

        console.log("bbox all");
        console.log(bboxAll);

        if (!bboxAll) setBBoxAll(resizedbounds);


    }



    function focusAll() {
        let bounds = turf.bbox(featureCollection);
        let resizedbounds = resizeBoundingBox(bounds);
        applyBoundingBox(resizedbounds);
    }





    function waitForResults(collection, results) {

        showAlert("green", "Przetwarzanie zakończone", 2000);
        setFileIsSelected(true);

        setLabFeatures(results);
        console.log('features after match');
        console.log(collection);

        collection.features.forEach(element => {
            delete element.properties.selected;
            if (element.exam_percent > 80) element.selected = true;
        });

        console.log('features after match');
        console.log(collection);

        setFeatureCollection(collection);
        setSendDisabled(false);


    }



    function filterLabResults() {
        setShowLabFilterCard(true);
    }




    function processResults() {

        if (!examDate.startDate) {
            showAlert("yellow", "Uzupełnij datę wykonania badań dla wybranego pliku", 2000);
            return;
        }

        setFileIsSelected(false);
        showAlert("green", "Przypisuję wyniki badań do pól", 2000);

        var timeStamp = Date.parse(examDate.startDate);

        setTimeout(() => matchFieldsResults(featureCollection, labFeatures, timeStamp, fileid, waitForResults), 200);

    }



    function applyFeatureCollection(collection) {
        //localStorage.setItem('featureCollection', JSON.stringify(collection));
        dispatchEvent(new CustomEvent("featureCollectionChangedPanel", { detail: collection }));
    }

    function applyFeatures(collection) {
        //localStorage.setItem('featureCollection', JSON.stringify(collection));
        dispatchEvent(new CustomEvent("featureCollectionChangedPanel", { detail: { features: collection } }));
    }

    function applyFocused(collection) {
        //localStorage.setItem('featureCollection', JSON.stringify(collection));
        //dispatchEvent(new CustomEvent("featureCollectionChangedPanel", { detail: { focused: collection } }));
    }

    function applyLabFeatures(collection) {
        //localStorage.setItem('featureCollection', JSON.stringify(collection));
        dispatchEvent(new CustomEvent("featureCollectionChangedPanel", { detail: { labFeatures: collection } }));
    }


    function applyBoundingBox(bounds) {
        //localStorage.setItem('boundingBox', JSON.stringify(bounds));
        dispatchEvent(new CustomEvent('boundingBoxChangedPanel', { detail: bounds })); //cool can pass arguments in event this way
    }


    function clearAllResults() {
        featureCollection.features.forEach(element => {
            delete element.exam_percent;
            delete element.area;
            delete element.examined;
        })
    }

    function arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }


    function handleFileResponse(data) {

        console.log(data);
        setSendDisabled(false); //odblokuj przycisk wyślij
        if (data.status === "ok") {
            showAlert("green", data.message, 2000);
            setRefreshAfterExit(true);
            getUserFiles(session, ownerid, setFiles, "json");
        }
        if (data.status !== "ok") {
            showAlert("red", data.message, 3000);
        }
    }


    function handleFieldResponse(data) {

        console.log(data);
        setSendDisabled(false); //odblokuj przycisk wyślij
        if (data.status === "ok") {
            showAlert("green", data.message, 2000);
            setRefreshAfterExit(true);

        }
        if (data.status !== "ok") {
            showAlert("red", data.message, 3000);
        }
    }


    function updateLabFile() {
        setSendDisabled(true); //tymczasowo zablokuj przycisk wyślij
        
        console.log('labFile')
        console.log(labFile);
        var properties = JSON.parse(labFile.properties);
        properties.parsed = Date.now();
        var bodydata = JSON.stringify({ action: action, session: session, id: fileid, owner: labFile.owner, field: labFile.field, filename: labFile.fileName, title: labFile.title, category: labFile.category, extension: labFile.ext, date: labFile.date, properties: JSON.stringify(properties), jsondata: JSON.stringify(labFeatures), binarydata: arrayBufferToBase64(labFile.data) });

        console.log('Update file');
        console.log(bodydata);

        fetch('https://online.mysoil.pl/cgi-bin/files.py', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodydata,
            mode: 'cors'
        })
            .then(res => res.json())
            .then(data => handleFileResponse(data))

    }

    function newLabFile(title, examDate, collection) {

        setSendDisabled(true); //tymczasowo zablokuj przycisk wyślij
        var action = "create";
        if (fileid > 0) action = "update";

        let properties = { size: fileSize, type: fileType, date: fileDate }
        let dateString = "";
        if (examDate.startDate) dateString = examDate.startDate;

        properties.parsed = Date.now();
        var bodydata = JSON.stringify({ action: action, session: session, id: fileid, owner: ownerid, field: 0, filename: fileName, title: title, category: "results", extension: extension, date: dateString, properties: JSON.stringify(properties), jsondata: JSON.stringify(collection), binarydata: arrayBufferToBase64(fileData) });

        console.log('lab file request');
        console.log(bodydata);



        fetch('https://online.mysoil.pl/cgi-bin/files.py', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodydata,
            mode: 'cors'
        })
            .then(res => res.json())
            .then(data => handleFileResponse(data))

    }


    function saveProcessResults() {
        setSendDisabled(true);
        
        updateLabFile(title, examDate, labFeatures);

        updateFieldsFromCollection();

    }



    function collectFeatures(feature) {
        if (!feature) return;
        collection.features.push(feature);
        if ((expectFeatures > 0) && (collection.features.length == expectFeatures))
            collectFinished();
    }


    function collectFinished() {
        console.log('finished collection');
        console.log(collection);

        for (let i = 0; i < collection.features.length; i++) {
            collection.features[i].properties.value = 9;
        }

        setLabFeatures(collection);
        applyLabFeatures(collection);
        setFileIsSelected(true);
        showGeoJson(collection, true);
        collection = emptyGeoJson;

        setFileId(0);
        setAction("create");
        setShowLabFilterCard(true);
        setFileIsFiltered(true);
    }


    function getFileInfo(file) {
        setFileInfo(file);
        setFileName(file.name);
        setExtension(file.name.split('.').pop());
        setFileSize(file.size);
        setFileType(file.type);
        setFileDate(file.lastModified);
    }



    function getFileData(data) {
        setFileData(data); //binary data from lab
    }



    function getFilterResults(title, examDate, collection) {
        setExamDate(examDate);

        setExamDate(examDate);
        setExamDateString(examDate.startDate);
        setTitle(title);
        setLabFeatures(collection);
        setShowLabFilterCard(false);

        newLabFile(title, examDate, collection); 

    }




    function updateField() {

        try {
            let field = fields.filter(f => f.id == fieldid)[0];

            var bodydata = JSON.stringify({ action: "updateshape", session: session, id: fieldid, shape: JSON.stringify(featureCollection) });

            fetch('https://online.mysoil.pl/cgi-bin/fields_test.py', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: bodydata,
                mode: 'cors'
            })
                .then(res => res.json())
                .then(data => handleFieldResponse(data))

        }
        catch { }
    }

    function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms || 100));
    }

    function getDateStrFromTimestamp(timestamp)
    {
        var date = new Date(timestamp);
        return (date.getFullYear() + "-" + zeroPad(date.getMonth() + 1) + "-" + zeroPad(date.getDate()));
    }





    function updateFieldsFromCollection() {
        try {

            featureCollection.features.forEach(feature => {
                console.log("feature");
                console.log(feature);
                if (feature.selected == true) {
                    var fieldid = feature.fieldid;
                    if (feature.examtime)
                    {
                    console.log("try testdate");
                    var testdate=getDateStrFromTimestamp(feature.examtime);                     
                    console.log("testdate");
                    console.log(testdate);

                    var tested={startDate:testdate,endDate:testdate};
                    }
                    var tempfc = {
                        "type": "FeatureCollection",
                        features: [feature]
                    };

                    delete tempfc.features[0].fieldid;
                    delete tempfc.features[0].selected;
                    
                    console.log("temp fc");
                    console.log(tempfc);
                    
                    var bodydata = JSON.stringify({ action: "updateexam", session: session, id: fieldid, tested:JSON.stringify(tested), shape: JSON.stringify(tempfc) });
                    console.log("body data");
                    console.log(bodydata);
                    

                    fetch('https://online.mysoil.pl/cgi-bin/fields_test.py', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: bodydata,
                        mode: 'cors'
                    })
                        .then(res => res.json())
                        .then(data => handleFieldResponse(data))
                }
            });
        }
        catch { /* */ }
    }



    function zeroPad(n) {
        return n > 9 ? "" + n : "0" + n;
    }


    function selectFile(e) {
        const id = e.currentTarget.getAttribute("data-fileid");
        selectFileById(id);
    }


    function selectFileById(id) {
        setFileId(id);
        let file;
        let labFeats;
        try {
            file = results.filter(r => r.id == id)[0];
            setLabFile(file);
            labFeats = JSON.parse(file.jsondata);

            for (let i = 0; i < labFeats.features.length; i++) {
                labFeats.features[i].properties.value = 9;
            }

            setLabFeatures(labFeats);
            applyLabFeatures(labFeats);
            setFileIsSelected(true);
            setTitle(file.title);
            setExtension(file.extension);
            setFileIsFiltered(true);

            featureCollection.features.forEach(element => {
                delete element.exam_percent;
                delete element.area;
            })

            //works for date and timesamp
            let fileExam = Date.parse(file.date);
            let dstring = file.date;
            setExamDate({ startDate: dstring, endDate: dstring });
            console.log('fileexam');
            console.log(fileExam);

            if (isNaN(fileExam)) { fileExam = Number(file.date); }
            if (!isNaN(fileExam)) {
                setExamTimeStamp(fileExam);

                /*
                let date = new Date(fileExam);
                console.log('date');
                console.log(date);

                setExamDateString(date.getFullYear() + "-" + zeroPad(date.getMonth() + 1) + "-" + zeroPad(date.getDay()));
                */
            }


            setFeatureCollection(featureCollection);
            setAction("update");
        } catch { console.log('catch!'); };
    }



    function handleFileCardClose(refresh) {
        if ((refresh) && (fieldid)) getFieldFiles(session, props.fieldid, setFiles);
        setShowFileCard(false);
    }





    function resizeBoundingBox(bounds) {
        var point1 = turf.point([bounds[0], bounds[1]]);
        var point2 = turf.point([bounds[2], bounds[3]]);
        var bearing = turf.bearing(point1, point2);
        var distance = turf.distance(point1, point2);
        var p1 = turf.destination(point1, -0.02 * distance, bearing);
        var p2 = turf.destination(point2, 0.02 * distance, bearing);
        var box = [p1.geometry.coordinates[0], p1.geometry.coordinates[1], p2.geometry.coordinates[0], p2.geometry.coordinates[1]];
        return box;
    }









    function updateTest() {
        setTimeout(() => updateLabFile(), 500);
    }


    function showGeoJson(feature, refresh) {
        if (!feature) return;

        let collection;
        try {
            if (feature.type == "FeatureCollection") {
                collection = feature;
            }
            else if (feature.type == "Feature") {
                collection = {
                    "type": "FeatureCollection",
                    features: [feature]
                }
            }
        } catch { console.log('unknown feature type'); }

        if (collection.features.length == 0) {
            console.log('No features to display');
            return;
        }

        console.log('Featrue Collection ready to display');
        //setFeaturesCount(collection.features.length);

        let area = turf.area(feature) / 10000.0;
        let bounds = turf.bbox(feature);
        let center = turf.center(feature);
        let resizedbounds = resizeBoundingBox(bounds);

        //grid(resizedbounds, collection);
        //gridtest(resizedbounds, collection);

        console.log('ApplyFC');
        applyFeatureCollection(collection);
        console.log('ApplyBB');
        applyBoundingBox(resizedbounds);


        console.log('SetShape');
        setShape(JSON.stringify(feature));

        //console.log('Before refresh '  + refresh);    
        //if (refresh==true) setShowPreview(true);
    }



    function cancelClose() {
        //localStorage.setItem("lockvehicles", "false");
        console.log("close on send : " + closeOnSend);

        if (clearOnExit) {
            applyFeatureCollection(emptyGeoJson);
        }
        props.Close(false);
    }






    function selectFieldItem(e) {
        const idx = e.currentTarget.getAttribute("data-fieldindex");
        console.log('select field' + idx);
        /*
        for (let i=0;i<featureCollection.features.length;i++)
        {
            if (i==idx) { featureCollection.features[i].properties.value=7; }
                else { featureCollection.features[i].properties.value=5;  }
        }
        */
        console.log(featureCollection);
        setFeatureCollection(featureCollection);
        let feature = featureCollection.features[idx];
        let bounds = turf.bbox(feature);
        let resizedbounds = resizeBoundingBox(bounds);

        setBoundingBox(resizedbounds);
        applyBoundingBox(resizedbounds); //panel map box only
        applyFeatures(featureCollection);
        applyFocused(feature);
    }


    function selectLabItem(e) {
        const idx = e.currentTarget.getAttribute("data-labindex");


        setLabFeatures(labFeatures);
        let feature = labFeatures.features[idx];
        let bounds = turf.bbox(feature);
        let resizedbounds = resizeBoundingBox(bounds);
        setBoundingBox(resizedbounds);
        applyBoundingBox(resizedbounds); //panel map box only
        applyLabFeatures(labFeatures);
        applyFocused(feature);
    }


    function getLastExam(examined) {
        //console.log('get last exam');
        //console.log(examined);
        examined.sort((a, b) => b.timestamp - a.timestamp); //sort descending
        return examined[0];

    }

    /////////////////////////////////////////

    function SingleField(props) {
        const [checked, setChecked] = useState(props.selected || false);
        const [index] = useState(props.index);
        //const [checked,setChecked] = useState(true);
        //const [fieldName, setFieldName] = useState(props.name);


        React.useEffect(() => {
            setChecked(props.selected);
        }, [props.selected]);


        function toggle() {
            setChecked(!checked);
            //console.log("changing feature " + index);
            featureCollection.features[index].selected=!checked;            
            //console.log(featureCollection.features[index].selected);
            //changeFieldChecked(props.index,!checked);
        }

        function changeName(name) {
            //setFieldName(name);
            //changeFieldName(props.index,name);
        }


        return (
            <ListItem key={props.index} className='py-0 px-0 mx-0 text-sm w-full' data-fieldindex={props.index} >
                <ListItemPrefix className='p-0 m-0'>
                    <Checkbox size="sm" className='m-auto p-0 w-4 h-4 rounded-md' checked={checked} onChange={toggle}></Checkbox>
                </ListItemPrefix>
                <div data-fieldindex={props.index} className='whitespace-pre-wrap' onClick={selectFieldItem}> {props.content}</div>
                <ListItemSuffix >{props.examval}</ListItemSuffix>
            </ListItem>
        )
    }

    /////////////////////////////////////////
    {/**
        <ListItem key={index} className='p-3 mx-0 text-sm' data-fieldindex={index} onClick={selectFieldItem}>
            {content}
        </ListItem>


*/}



    function RenderFieldFeatureList(param) {

        if (!Array.isArray(param.collection.features)) return;
        return (
            param.collection.features.map(({ properties, area, examined, fieldid, selected, exam_percent }, index) => {
                var content = (index + 1).toString();
                content = "";
                if (properties.nazwa) { content += "  " + properties.nazwa; }
                else content += "  Pole bez nazwy "
                var examstr = "";
                if (area) content += " (" + area + " ha)";
                if (examined) {
                    var last = getLastExam(examined);

                    if (last.timestamp > 0) {
                        var date = new Date(last.timestamp);
                        content += " Przebadane " + date.getFullYear() + "-" + zeroPad(date.getMonth() + 1) + "-" + zeroPad(date.getDate());
                    }

                    if (last.percent > 0) examstr = last.percent.toString() + "%";
                } //if examined
                return (
                    <SingleField key={index} index={index} content={content} examval={examstr} selected={selected} />
                )
            } //map
            )
        )
    }





    function RenderLabFeatureList(param) {

        if ((!param.features) || (!Array.isArray(param.features.features))) return (
            <div></div>
        )

        return (
            param.features.features.map(({ properties, area, assigned_to }, index) => {
                var content = (index + 1).toString();
                content += " obszar "
                if (area) content += " ( " + Math.round(area / 100) / 100 + " ha )";
                if (assigned_to) content += " [pole nr " + assigned_to + "]";
                return (
                    <ListItem key={index} className='p-3 mx-0 text-sm' data-labindex={index} onClick={selectLabItem}>
                        {content}
                    </ListItem>
                )
            }
            )
        )
    }


    function RenderFilesList(params) {
        if (params.files.length > 0)
            return (

                <div className='w-full mx-[0.5rem] my-1 flex flex-wrap gap-2'>
                    {results.map(({ id, title, filename, extension }) => {


                        if (title == "") title = "Nowy Plik";
                        console.log(filename, extension);

                        return (
                            <div key={id} className={`flex flex-col gap-1 rounded-md w-[6rem] max-h-[8rem]  ${id == fileid ? 'bg-teal-100 border border-2 border-teal-200' : 'bg-teal-50/50'}`} data-fileid={id} onClick={selectFile}>

                                <DocumentIcon extension={extension} className='h-8 w-10 mx-auto my-1 flex' innerClassName="pl-2"></DocumentIcon>

                                <div className='line-clamp-2'>
                                    <Typography variant="small" label="Tytuł" className="text-center mx-auto font-normal text-xs text-blue-500" >{title}</Typography>
                                </div>

                            </div>
                        )
                    })}
                </div>

            )
        else return (<></>);
    }





    return (

        <div className='fixed w-full h-full top-0 left-0 items-center justify-center m-auto z-[10] flex place-content-center bg-black/50 '>

            <Card color="white" className="w-auto max-w-[90vw] mx-auto rounded-lg shadow-lg max-h-[94vh] " shadow={true}>

                <div className="flex justify-between gap-2 w-auto mt-2">
                    <Typography color="gray" className="mt-0 pl-12 font-normal mx-auto">
                        Przetwarzanie wyników badań
                    </Typography>
                    <IconButton variant='text' className='-top-1 right-2' color="blue-gray" data-refresh={false} onClick={cancelClose}>
                        <XMarkIcon className='w-6 h-6' />
                    </IconButton>
                </div>
                <div className="w-auto flex flex-row items-start gap-2 m-2">


                    <div id="list of client features" className='p-1 w-[17rem] h-[80vh] overflow-y-auto overflow-x-hidden border border-green-100 rounded-lg'>

                        <div className="flex justify-between w-auto bg-green-100 rounded-lg"  >
                            <Typography color="Black" className="mt-0 p-2 font-normal mx-auto text-center cursor-pointer" onClick={focusAll}>
                                Pola wybranego klienta
                            </Typography>
                        </div>

                        <List className='p-0 mr-1 w-full '>
                            <RenderFieldFeatureList collection={featureCollection} />
                        </List>

                    </div>



                    <div id="map" className='rounded-lg p-1 bg-blue w-auto h-auto'>
                        <div id="list of imported files" className='flex flex-row mb-4 h-auto rounded-lg border border-green-100'>
                            <RenderFilesList files={results}></RenderFilesList>
                        </div>
                        <div id="buttons" className='flex flex-row mb-4 h-[3.5rem] rounded-lg border border-blue-100 p-2'>
                            {/*
                            <Typography color="black" className="py-1 my-auto font-normal ml-2 mr-auto text-sm text-center">
                                {
                                    (examDate) && "Data badania : " + examDate
                                }
                                {
                                    (!labFile) && "Wybierz plik badań "
                                }

                            </Typography>
                            <ShapeUnziper className="ml-0 mr-0 mt-[2rem]" iconOnly={true} fullbutton={true} geoJson={collectFeatures} finished={collectFinished} fileinfo={getFileInfo} filedata={getFileData} tooltip="Dodaj nowy plik" allowpdf={true} />        
                            */}
                            <ShapeUnziper className="ml-2 mr-auto" iconOnly={true} fullbutton={true} geoJson={collectFeatures} finished={collectFinished} filedata={getFileData} fileinfo={getFileInfo} tooltip="Wczytaj plik badań" text="Wczytaj plik badań" allowpdf={false} />

                            <Button className="flex items-center gap-2 mx-auto" size="sm" color="blue" disabled={!fileIsSelected} onClick={filterLabResults}>
                                <FunnelIcon strokeWidth={2} className="h-4 w-4" />Filtruj wyniki badań
                            </Button>


                            <Button className="flex items-center gap-2 mx-auto" size="sm" color="yellow" disabled={!fileIsFiltered} onClick={processResults}>
                                <BeakerIcon strokeWidth={2} className="h-4 w-4" />Przetwórz wyniki badań
                            </Button>



                            <Button className="flex items-center gap-2 mx-auto" size="sm" color="green" disabled={sendDisabled} onClick={saveProcessResults}>
                                <InboxIcon strokeWidth={2} className="h-4 w-4" />Zapisz wyniki
                            </Button>

                            <IconButton variant='gradient' className='ml-2 h-auto' color="red" onClick={() => setShowConfirmClear(true)}>
                                <TrashIcon className='w-5 h-5' />
                            </IconButton>

                        </div>

                        <div id="map" className='rounded-lg border border-green-100'>
                            <MapboxPanel features={featureCollection} labFeatures={labFeatures} boundingBox={boundingBox} min={0} max={10} selected="value" style={{ position: 'relative', width: '50vw', height: '62vh', cornerRadius: "20px", margin: "5px" }} />
                        </div>
                    </div>



                    <div id="list of lab results features" className='p-1 w-[16rem] h-[80vh] overflow-y-auto overflow-x-hidden border border-green-100 rounded-lg'>
                        <div className="flex justify-between w-auto bg-green-100 rounded-lg ">
                            <Typography color="black" className="mt-0 p-2 font-normal mx-auto text-center">
                                {
                                    (!labFeatures.features) && "Wybierz badanie do importu"
                                }
                                {
                                    (labFeatures.features) && "Wyniki badań (" + labFeatures.features.length + ")"
                                }

                            </Typography>
                        </div>

                        <List className='p-0 mx-0 w-full'>
                            <RenderLabFeatureList features={labFeatures} />
                        </List>

                    </div>

                </div>
            </Card>
            <ConfirmDialog open={showConfirmClear} message="Czy na pewno chcesz usunąć informacje o badaniach wybranej grupy pól ?" onCancel={() => setShowConfirmClear(false)} onConfirm={clearAllResults} />
            {showLabFilterCard && <LabFilterCard labFeatures={labFeatures} cancel={setShowLabFilterCard} onFinish={getFilterResults} title={title} examDate={examDate} />}
        </div>

    );

}



